import type { FaireProductEntity } from "../../entity_types/product";

export const p_786nz0ery4: FaireProductEntity = {
  token: "p_786nz0ery4",
  type: "product",
  name: "Not Counting Candles Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/921a86ce2df729d9e8bfda4321906b551edf8df238674b5b3f5ba6becdc6f942/1558020467.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/138e91a194d028f7e2fc2009fc323a192a8925dab5741592cda98ef148777e52/1558020491.png",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:33.910Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
